import NativeAppMessagingContainer from "./NativeAppMessagingContainer";

export default NativeAppMessagingContainer;
